// extracted by mini-css-extract-plugin
module.exports = {"box":"Answer_box__19SIy","selected":"Answer_selected__3NgHr","image":"Answer_image__Dmyld","text":"Answer_text__29wbZ"};